var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat209(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_209"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_209",
    "data-name": 209,
    className: "cls-2",
    d: "M98.32,47.64C99,35.88,62,19.84,31.11,25.23,15.41,28-.56,40.43,2.78,58,9,90.42,51.51,72.63,70.32,64.44,88.81,56.39,98,52.36,98.32,47.64Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat209);
export default __webpack_public_path__ + "static/media/cat_209.0fe5d87f04750dd8b33417e1a9d4417d.svg";
export { ForwardRef as ReactComponent };